// TODO ZL-856: replace this custom infrastructure with Firebase Remote Config
import { FeatureFlag } from './schema'
import { useFeatureFlags } from './useFeatureFlags'
import { useGlobalFeatureFlags } from './useGlobalFeatureFlags'

export const useIsFeatureFlagEnabled = (feature: FeatureFlag): boolean => {
  const { data: userFlags } = useFeatureFlags()
  const { data: globalFlags } = useGlobalFeatureFlags()

  const userValue = userFlags?.entity.features[feature]
  const globalValue = globalFlags?.features[feature]

  // User-level explicitly set (true or false) takes precedence over global.
  return (userValue !== undefined ? userValue : globalValue) === true
}
